import type { SVGProps } from 'react';
const SvgIconSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path
      fill="#1A202C"
      d="M16.037 10.268a5.769 5.769 0 1 0-11.537 0 5.769 5.769 0 0 0 11.537 0m-1.114 5.88a7.46 7.46 0 0 1-4.655 1.62 7.5 7.5 0 0 1-7.499-7.5 7.5 7.5 0 0 1 7.5-7.499 7.499 7.499 0 0 1 5.879 12.154l4.829 4.828a.865.865 0 0 1-1.222 1.222l-4.832-4.824z"
    />
  </svg>
);
export default SvgIconSearch;
